
export class LossAmountRangeModel {
    id: string;
    name: string;
    category: string;
    minValue: string;
    maxValue: string;
}


// WEBPACK FOOTER //
// ./src/app/modules/eldm-param-value/entities/lost-amount-range-model.ts